import { type TextFieldProps } from "@mui/material";
import { TextInput, type TextInputProps } from "@src/appV2/redesign/components/TextInput";
import { forwardRef } from "react";

export const PickerTextInput = forwardRef<HTMLDivElement, TextFieldProps>(
  function PickerTextInput(props, _rootRef) {
    // MUI picker textField slots provide a root ref, while TextInput forwards refs to the input.
    return <TextInput {...(props as Omit<TextInputProps, "ref">)} />;
  }
);
